import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { overviewFieldLabelTypography } from './overviewFieldStyles';

/**
 * Styling for the Account Overview General Information card's card-specific chrome:
 * the "editing" info strip, the read-mode links (Add URL / Configure Email / etc.), the
 * email "domain (provider)" lines, and the edit-mode field wrappers that reserve the same
 * 48px (`THEME.spacing.xxxl`) min-height as their read-mode counterparts so toggling modes
 * never jumps the layout. All tokens come from `THEME`; the literal 15px value mirrors the
 * hifi design and the existing `overviewFieldStyles` (which has no scale equivalent for it).
 */
export const generalInformationCardStyles = StyleSheet.create({
	infoStrip: {
		alignItems: 'center',
		backgroundColor: THEME.colors.primary.light,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.primary.dark,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.sm,
		marginBottom: THEME.spacing.lg,
		padding: `${THEME.spacing.sm + 1}px ${THEME.spacing.md - 2}px`,
	},
	link: {
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		fontSize: 15,
		// Override the components-v2 Button's fixed height/padding so the action link sits inline
		// (no-op for the anchor variant, which has neither by default).
		height: 'auto',
		padding: 0,
		textDecoration: 'none',
		width: 'fit-content',
		':hover': {
			color: THEME.colors.hover.main,
		},
	},
	emailProviderName: {
		color: THEME.colors.text.light,
	},
	planWebsiteLine: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
	// Legacy treatment: a CANCELED account's Status reads bold red so it can't be missed.
	cancelledStatus: {
		color: THEME.colors.danger.main,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	// Reserve the read-field min-height so toggling edit mode doesn't jump the layout. Flex column, gap,
	// and full-width children are provided by the components-v2 `Field` (vertical orientation).
	editField: {
		minHeight: THEME.spacing.xxxl,
	},
	editLabel: {
		...overviewFieldLabelTypography,
	},
	// Warning shown when an account has no email provider configuration at all (legacy parity).
	emailNotConfigured: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.xxs,
	},
	// Keeps the prediction text and its reason-indicator icon on one baseline (legacy parity).
	willRenewPredictionValue: {
		alignItems: 'center',
		display: 'inline-flex',
		gap: THEME.spacing.xs,
	},
});
